<template>
    <div class="account-details-contacts-tab tab-contents">
        <NoResults v-if="totalItems < 1"
                   icon="fa-solid fa-user-slash"
                   color="light"
                   lang="MANAGE_ACCOUNT.NO_CONTACTS" />
        <template v-else>
            <ContactsList :contacts="visibleContacts"></ContactsList>

            <Pager v-model="currentPage"
                   class="mt-1"
                   :total-items="totalItems"
                   :page-size="pageSize" />
        </template>
    </div>
</template>

<script>
import ContactsList from '@/epos/vue/components/Customers/ContactsList';
import NoResults from '@/vue/components/NoResults';
import Pager from '@/vue/components/Pager';

export default {
    components: { NoResults, ContactsList, Pager },

    props: {
        /**
         * @type {CustomerAccount}
         */
        account: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            currentPage: 1,
            pageSize: 10,
        };
    },

    computed: {
        /**
         * @returns {Contact[]}
         */
        contacts() {
            return this.account.contacts;
        },

        /**
         * @returns {Contact[]}
         */
        visibleContacts() {
            // Return a chunk of this.contacts for the current page:
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.contacts.slice(start, end);
        },

        /**
         * @returns {number}
         */
        totalItems() {
            return this.contacts.length;
        },
    },
};
</script>
